/* tslint:disable */
/* eslint-disable */
/**
 * BROStar API
 * Simplify the data management of the BRO
 *
 * The version of the OpenAPI document: v1
 * Contact: servicedesk@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { DesignLoop } from "./DesignLoop";
import {
  DesignLoopFromJSON,
  DesignLoopFromJSONTyped,
  DesignLoopToJSON,
  DesignLoopToJSONTyped,
} from "./DesignLoop";

/**
 *
 * @export
 * @interface ApiGufLoopsList200Response
 */
export interface ApiGufLoopsList200Response {
  /**
   *
   * @type {number}
   * @memberof ApiGufLoopsList200Response
   */
  count: number;
  /**
   *
   * @type {string}
   * @memberof ApiGufLoopsList200Response
   */
  next?: string | null;
  /**
   *
   * @type {string}
   * @memberof ApiGufLoopsList200Response
   */
  previous?: string | null;
  /**
   *
   * @type {Array<DesignLoop>}
   * @memberof ApiGufLoopsList200Response
   */
  results: Array<DesignLoop>;
}

/**
 * Check if a given object implements the ApiGufLoopsList200Response interface.
 */
export function instanceOfApiGufLoopsList200Response(
  value: object
): value is ApiGufLoopsList200Response {
  if (!("count" in value) || value["count"] === undefined) return false;
  if (!("results" in value) || value["results"] === undefined) return false;
  return true;
}

export function ApiGufLoopsList200ResponseFromJSON(json: any): ApiGufLoopsList200Response {
  return ApiGufLoopsList200ResponseFromJSONTyped(json, false);
}

export function ApiGufLoopsList200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ApiGufLoopsList200Response {
  if (json == null) {
    return json;
  }
  return {
    count: json["count"],
    next: json["next"] === undefined ? undefined : json["next"] === null ? null : json["next"],
    previous:
      json["previous"] === undefined
        ? undefined
        : json["previous"] === null
        ? null
        : json["previous"],
    results: (json["results"] as Array<any>).map(DesignLoopFromJSON),
  };
}

export function ApiGufLoopsList200ResponseToJSON(json: any): ApiGufLoopsList200Response {
  return ApiGufLoopsList200ResponseToJSONTyped(json, false);
}

export function ApiGufLoopsList200ResponseToJSONTyped(
  value?: ApiGufLoopsList200Response | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    count: value["count"],
    next: value["next"],
    previous: value["previous"],
    results: (value["results"] as Array<any>).map(DesignLoopToJSON),
  };
}
